import React, { useEffect, useRef, useState } from 'react';
import Joyride, { CallBackProps, Props, Step } from 'react-joyride';
import { atomWithStorage } from 'jotai/utils';
import { useAtom } from 'jotai';
import CustomTooltipProgress from '@components/progress/breakdown/onboarding/CustomTooltipProgress';
import { useViewWidth } from '@utils/helpers/viewWidth';

const showAtom = atomWithStorage('show-new-progress-onboarding', true);

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const BreakdownOnboarding = () => {
  const [show, setShow] = useAtom(showAtom);
  const [step, setStep] = useState(
    Number(localStorage.getItem('new-progress-step') || 0),
  );
  const [firstId, setFirstId] = useState('');
  const [hide, setHide] = useState(false);
  const width = useViewWidth();

  // delay the rendering until the dom is ready
  const interval = useRef<ReturnType<typeof setInterval>>();
  function checkReadyState() {
    if (document.getElementsByClassName('topic-label').length > 0) {
      setFirstId(document.getElementsByClassName('topic-label')[0].id);
      clearInterval(interval.current);
    }
  }
  useEffect(() => {
    if (show) {
      interval.current = setInterval(() => {
        checkReadyState();
      }, 1000);
    }

    return () => clearInterval(interval.current);
  }, []);

  // subscribe to local storage step
  const pollStep = useRef<ReturnType<typeof setInterval>>();
  function checkStep() {
    setStep(Number(localStorage.getItem('new-progress-step') || 0));
  }
  useEffect(() => {
    if (show) {
      pollStep.current = setInterval(() => {
        checkStep();
      }, 100);
    }

    return () => clearInterval(pollStep.current);
  }, []);

  // when resizing, we hide it first and show it again after resize. So it will not appear buggy
  const timeoutUnhide = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => {
    if (show) {
      setHide(true);
      clearTimeout(timeoutUnhide.current);
      timeoutUnhide.current = setTimeout(() => {
        setHide(false);
      }, 200);
    }
  }, [width, show]);

  function callback(data: CallBackProps) {
    if (data.action === 'close') {
      setShow(false);
      clearInterval(pollStep.current);
    }
  }

  // after 5 second of the last step, close the onboarding
  useEffect(() => {
    if (step == 1) {
      setTimeout(() => {
        setShow(false);
      }, 5000);
    }
  }, [step]);

  const steps: Step[] = [
    {
      target: '#' + firstId,
      content: 'NEW! Click on this row to reveal more information.',
      placement: width >= breakpoint.lg ? 'right' : 'bottom',
      disableBeacon: true,
      disableScrolling: true,
      disableOverlayClose: true,
      spotlightClicks: true,
    },
  ];

  if (width >= breakpoint.lg) {
    steps.push({
      target: '#breakdown-section',
      content: 'Now you can view all your topic details here!',
      placement: 'bottom',
      disableBeacon: true,
      disableOverlayClose: false,
      disableScrolling: true,
    });
  }

  const props: Props = {
    steps: steps,
    stepIndex: step,
    run: true,
    continuous: false,
    callback: callback,
    tooltipComponent: CustomTooltipProgress,
  };

  if (!show || !firstId || hide) {
    return null;
  }

  return <Joyride {...props} />;
};

export default BreakdownOnboarding;
